(function($) {
	$(function() {

	});
})(jQuery);